<script setup lang="ts">
defineOptions({
  name: 'TeamPage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Team</Title>
      <Meta
        name="description"
        content="Lernen Sie das Team von johnsenpartner. architekten kennen – erfahrene Architekten und Bauleiter aus Solingen."
      />
    </Head>
    <TeamIntro />
    <TeamGallery />
  </div>
</template>
